
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as activateKZMgVYNvtcMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/activate.vue?macro=true";
import { default as email_45change79hV0CRPA2Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/email-change.vue?macro=true";
import { default as indexPVs6hxWwmFMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/index.vue?macro=true";
import { default as register_45completeD2OyXfhyyhMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/register-complete.vue?macro=true";
import { default as registerbzbxG6Wyb0Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/register.vue?macro=true";
import { default as restoreR8GueySXMDMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/restore.vue?macro=true";
import { default as indexzb2QzAYXqsMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/buzzer/index.vue?macro=true";
import { default as _91id_93CiIhmm1tiBMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/dashboards/[id].vue?macro=true";
import { default as indexh6c6WlCPM8Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/dashboards/index.vue?macro=true";
import { default as _91token_937oPAXqjeqEMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/dashboards/token/[token].vue?macro=true";
import { default as tokenSnHuymD1SZMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/dashboards/token.vue?macro=true";
import { default as demoPmvRkCVlLPMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/demo.vue?macro=true";
import { default as indexkM4MuXjSH9Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/events/index.vue?macro=true";
import { default as impressumaMneEHPYraMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/impressum.vue?macro=true";
import { default as indexKs1OfjWaKXMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/index.vue?macro=true";
import { default as _91id_93OIdEd1oB35Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/deals/[id].vue?macro=true";
import { default as indexyqorxp4ZDRMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/deals/index.vue?macro=true";
import { default as _91id_93S8Uqmy1zoEMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/devices/[id].vue?macro=true";
import { default as HSLtoRGBHqH5uHlpjCMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/devices/HSLtoRGB.js?macro=true";
import { default as indexoAMedfdOT1Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/devices/index.vue?macro=true";
import { default as RGBtoHSLkeZCbaKCZxMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/devices/RGBtoHSL.js?macro=true";
import { default as _91id_93IuWNqXsjwRMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/eventTypes/[id].vue?macro=true";
import { default as indexa285XtnpRMMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/eventTypes/index.vue?macro=true";
import { default as _91id_93lXRZu9ffOBMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/goals/[id].vue?macro=true";
import { default as indexj3ek6L6gd3Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/goals/index.vue?macro=true";
import { default as _91id_936LLFggnHprMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/groups/[id].vue?macro=true";
import { default as indexk18FTAOKgnMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/groups/index.vue?macro=true";
import { default as index0qVhpHLrblMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/settings/index.vue?macro=true";
import { default as indexCbW9toNpFSMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/subscriptions/index.vue?macro=true";
import { default as _91id_93NGeZd8gccAMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/users/[id].vue?macro=true";
import { default as indexuIobm0kHbvMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/users/index.vue?macro=true";
import { default as _91id_9390i75aND1MMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/sounds/[id].vue?macro=true";
import { default as entriesppvDDOAObyMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/sounds/index/entries.vue?macro=true";
import { default as playlistshQ6XROD8S1Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/sounds/index/playlists.vue?macro=true";
import { default as indexJzzKKX3mKPMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/sounds/index.vue?macro=true";
import { default as index0IA3Cn4Ux4Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/devices/index.vue?macro=true";
import { default as _91id_93gQ9mp3Cj2DMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/firmware/[id].vue?macro=true";
import { default as indexZpEXkTUAqHMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/firmware/index.vue?macro=true";
import { default as _91id_93WpZEHPb54wMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/hardware/[id].vue?macro=true";
import { default as indexRxUDUsZd0TMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/hardware/index.vue?macro=true";
import { default as indexDHJrPp8tFNMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/logs/index.vue?macro=true";
import { default as _91id_93qaBxsUmqf1Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/notificationTemplates/[id].vue?macro=true";
import { default as indexAicJIr830vMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/notificationTemplates/index.vue?macro=true";
import { default as _91id_93AUSRleMJOgMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/organisations/[id].vue?macro=true";
import { default as indexUeMF8BjtvWMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/organisations/index.vue?macro=true";
import { default as _91id_93KkAXD3LOZFMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/plans/[id].vue?macro=true";
import { default as indexkajXstvNObMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/plans/index.vue?macro=true";
import { default as releaselogBPlpHdIFNiMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/releaselog.vue?macro=true";
import { default as toolsVsrlmJuOazMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/tools.vue?macro=true";
import { default as _91id_93HdmgQDAdgqMeta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/users/[id].vue?macro=true";
import { default as indexO8lT4d0xp9Meta } from "/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/users/index.vue?macro=true";
export default [
  {
    name: "auth-activate",
    path: "/auth/activate",
    meta: activateKZMgVYNvtcMeta || {},
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/activate.vue")
  },
  {
    name: "auth-email-change",
    path: "/auth/email-change",
    meta: email_45change79hV0CRPA2Meta || {},
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/email-change.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexPVs6hxWwmFMeta || {},
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/index.vue")
  },
  {
    name: "auth-register-complete",
    path: "/auth/register-complete",
    meta: register_45completeD2OyXfhyyhMeta || {},
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/register-complete.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerbzbxG6Wyb0Meta || {},
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/register.vue")
  },
  {
    name: "auth-restore",
    path: "/auth/restore",
    meta: restoreR8GueySXMDMeta || {},
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/auth/restore.vue")
  },
  {
    name: "buzzer",
    path: "/buzzer",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/buzzer/index.vue")
  },
  {
    name: "dashboards-id",
    path: "/dashboards/:id()",
    meta: _91id_93CiIhmm1tiBMeta || {},
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/dashboards/[id].vue")
  },
  {
    name: "dashboards",
    path: "/dashboards",
    meta: indexh6c6WlCPM8Meta || {},
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/dashboards/index.vue")
  },
  {
    name: "dashboards-token",
    path: "/dashboards/token",
    meta: tokenSnHuymD1SZMeta || {},
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/dashboards/token.vue"),
    children: [
  {
    name: "dashboards-token-token",
    path: ":token()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/dashboards/token/[token].vue")
  }
]
  },
  {
    name: "demo",
    path: "/demo",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/demo.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/events/index.vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/impressum.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/index.vue")
  },
  {
    name: "organisation-deals-id",
    path: "/organisation/deals/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/deals/[id].vue")
  },
  {
    name: "organisation-deals",
    path: "/organisation/deals",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/deals/index.vue")
  },
  {
    name: "organisation-devices-id",
    path: "/organisation/devices/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/devices/[id].vue")
  },
  {
    name: "organisation-devices-HSLtoRGB",
    path: "/organisation/devices/HSLtoRGB",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/devices/HSLtoRGB.js")
  },
  {
    name: "organisation-devices",
    path: "/organisation/devices",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/devices/index.vue")
  },
  {
    name: "organisation-devices-RGBtoHSL",
    path: "/organisation/devices/RGBtoHSL",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/devices/RGBtoHSL.js")
  },
  {
    name: "organisation-eventTypes-id",
    path: "/organisation/eventTypes/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/eventTypes/[id].vue")
  },
  {
    name: "organisation-eventTypes",
    path: "/organisation/eventTypes",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/eventTypes/index.vue")
  },
  {
    name: "organisation-goals-id",
    path: "/organisation/goals/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/goals/[id].vue")
  },
  {
    name: "organisation-goals",
    path: "/organisation/goals",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/goals/index.vue")
  },
  {
    name: "organisation-groups-id",
    path: "/organisation/groups/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/groups/[id].vue")
  },
  {
    name: "organisation-groups",
    path: "/organisation/groups",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/groups/index.vue")
  },
  {
    name: "organisation-settings",
    path: "/organisation/settings",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/settings/index.vue")
  },
  {
    name: "organisation-subscriptions",
    path: "/organisation/subscriptions",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/subscriptions/index.vue")
  },
  {
    name: "organisation-users-id",
    path: "/organisation/users/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/users/[id].vue")
  },
  {
    name: "organisation-users",
    path: "/organisation/users",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/organisation/users/index.vue")
  },
  {
    name: "sounds-id",
    path: "/sounds/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/sounds/[id].vue")
  },
  {
    name: "sounds",
    path: "/sounds",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/sounds/index.vue"),
    children: [
  {
    name: "sounds-index-entries",
    path: "entries",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/sounds/index/entries.vue")
  },
  {
    name: "sounds-index-playlists",
    path: "playlists",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/sounds/index/playlists.vue")
  }
]
  },
  {
    name: "system-devices",
    path: "/system/devices",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/devices/index.vue")
  },
  {
    name: "system-firmware-id",
    path: "/system/firmware/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/firmware/[id].vue")
  },
  {
    name: "system-firmware",
    path: "/system/firmware",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/firmware/index.vue")
  },
  {
    name: "system-hardware-id",
    path: "/system/hardware/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/hardware/[id].vue")
  },
  {
    name: "system-hardware",
    path: "/system/hardware",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/hardware/index.vue")
  },
  {
    name: "system-logs",
    path: "/system/logs",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/logs/index.vue")
  },
  {
    name: "system-notificationTemplates-id",
    path: "/system/notificationTemplates/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/notificationTemplates/[id].vue")
  },
  {
    name: "system-notificationTemplates",
    path: "/system/notificationTemplates",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/notificationTemplates/index.vue")
  },
  {
    name: "system-organisations-id",
    path: "/system/organisations/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/organisations/[id].vue")
  },
  {
    name: "system-organisations",
    path: "/system/organisations",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/organisations/index.vue")
  },
  {
    name: "system-plans-id",
    path: "/system/plans/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/plans/[id].vue")
  },
  {
    name: "system-plans",
    path: "/system/plans",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/plans/index.vue")
  },
  {
    name: "system-releaselog",
    path: "/system/releaselog",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/releaselog.vue")
  },
  {
    name: "system-tools",
    path: "/system/tools",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/tools.vue")
  },
  {
    name: "system-users-id",
    path: "/system/users/:id()",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/users/[id].vue")
  },
  {
    name: "system-users",
    path: "/system/users",
    component: () => import("/home/forge/cloud.deal-buzzer.com/releases/20260914072223/client/pages/system/users/index.vue")
  }
]